import { useAppDispatch, useAppSelector } from '@app/hooks'
import { logout } from '@features/auth/authSlice'

export const useAuth = () => {
  const { user, token } = useAppSelector((state) => state.auth)
  const dispatch = useAppDispatch()
  return {
    user,
    token,
    isAuthenticated: Boolean(token),
    logout: () => dispatch(logout()),
  }
}
